import { MUIColors } from '@/styles/theme'
import {
  FiscalNoteStatus as FiscalNoteStatusType,
  FiscalNoteStatusEnum,
} from '@/types'
import { Box, Chip, Typography } from '@mui/material'

interface FiscalNoteStatusProps {
  status: FiscalNoteStatusType
  type?: 'default' | 'chip' | 'dot'
}

const COLOR_BY_STATUS: Record<FiscalNoteStatusType, MUIColors> = {
  emission_requested: 'info',
  emitted: 'success',
  error: 'error',
  cancellation_requested: 'info',
  canceled: 'default',
  waiting_files: 'info',
}

const DOT_COLOR_BY_STATUS: Record<FiscalNoteStatusType, string> = {
  emission_requested: 'info.main',
  emitted: 'success.main',
  error: 'error.main',
  cancellation_requested: 'info.main',
  canceled: 'GrayText',
  waiting_files: 'info.main',
}

export function FiscalNoteStatus({
  type = 'default',
  status,
}: FiscalNoteStatusProps) {
  if (type === 'chip') {
    return (
      <Chip
        component="span"
        label={FiscalNoteStatusEnum[status]}
        color={COLOR_BY_STATUS[status]}
        size="small"
      />
    )
  }

  if (type === 'dot') {
    return (
      <Box
        width={12}
        height={12}
        bgcolor={DOT_COLOR_BY_STATUS[status]}
        borderRadius={6}
        flexShrink={0}
      />
    )
  }

  return (
    <Typography color={COLOR_BY_STATUS[status] as MUIColors}>
      {FiscalNoteStatusEnum[status]}
    </Typography>
  )
}
